import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoDirective } from "@jsverse/transloco";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CoreCommonModule } from "../../../../@core/common.module";

// import {
//     UploadFilesComponentStepComponent
// } from "../../pages/contract-control/modals/bulk-upload-modal/steps/upload-files-step/upload-files.component-step.component";
import { SharedModule } from "../shared/shared.module";


@NgModule({
  declarations: [
  ],
    imports: [
        CoreCommonModule,
        NgbModule,
        CommonModule,
        SharedModule,
        TranslocoDirective,
    ],
    exports:[
    ]
})
export class UploadFilesModule { }
